import CartFooter from './CartFooter';
import Footer from './Footer';

export default {
  CartFooter,
  Footer,
};
